import React from 'react'
import MessageBanner from 'LuxKit/Banners/MessageBanner'
import { withOfferPageAndReduxState } from 'contexts/OfferPage/withOfferPageState'
import TextLink from 'LuxKit/TextLink'

type AccommodationRoomTileKnownMessage =
  'loading' |
  'members-exclusive' |
  'sold-out-on-dates' |
  'sold-out' |
  'exceeded-capacity' |
  'sold-out-on-dates-or-exceeded-capacity' |
  'available-on-dates' |
  'available-on-dates-variant' |
  'available-for-some-rooms'

interface Props {
  message: AccommodationRoomTileKnownMessage
  offer: App.HotelOffer
  onMultiRoomModeClick?: () => void
}

function AccommodationRoomTileMessage(props: Props) {
  const {
    message,
    offer,
    onMultiRoomModeClick,
  } = props

  const messageLabel = (() => {
    switch (message) {
      case 'members-exclusive':
        return 'Sign up to access exclusive rates'
      case 'sold-out-on-dates':
        return `This ${offer.saleUnitLong} is sold out on your dates`
      case 'sold-out':
        return `This ${offer.saleUnitLong} is sold out`
      case 'exceeded-capacity':
        return 'Max number of guests exceeded'
      case 'sold-out-on-dates-or-exceeded-capacity':
        return <>This room is sold out on your dates or <br />
          Max number of guests exceeded
        </>
      case 'available-for-some-rooms':
        return onMultiRoomModeClick ?
            <>This room type works for some rooms in your group, but not all. To select it, try <TextLink onClick={onMultiRoomModeClick}>choosing rooms individually.</TextLink></> :
            <>This room type works for some rooms in your group, but not all. To select it, try choosing rooms individually.</>
    }
  })()

  if (!messageLabel) return null

  return <MessageBanner kind="informational-primary">
    {messageLabel}
  </MessageBanner>
}

export default withOfferPageAndReduxState((offerPageState) => ({
  offer: (offerPageState.offer ?? offerPageState.bedbankOffer)!,
}), AccommodationRoomTileMessage)
